var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.label.length ? _c("h3", [_vm._v(_vm._s(_vm.label))]) : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-6" },
        [
          _c("IcFormRowWrapper", {
            attrs: {
              rowElement: "IcFormRow",
              id: "type",
              name: "train.type",
              label: _vm.$t("label_train_type"),
              aria: _vm.$t("required"),
              labelWidth: 4,
              controlWidth: 8,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ validator }) {
                  return [
                    _c("IcSelect", {
                      attrs: { id: "type", values: _vm.trainTypes },
                      on: {
                        input: function ($event) {
                          return _vm.emitInput(_vm.data, validator)
                        },
                      },
                      model: {
                        value: _vm.data.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "type", $$v)
                        },
                        expression: "data.type",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      0 && _vm.data.type != "" && _vm.data.type != "Skład wagonowy"
        ? _c(
            "div",
            { staticClass: "col-4" },
            [
              _c("IcFormRowWrapper", {
                attrs: {
                  rowElement: "IcFormRow",
                  id: "count",
                  name: "train.count",
                  aria: _vm.$t("aria_required"),
                  label: _vm.$t("label_count"),
                  labelWidth: 4,
                  controlWidth: 8,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ validator }) {
                        return [
                          _c("IcInput", {
                            attrs: { id: "count", maxlength: "20" },
                            on: {
                              input: function ($event) {
                                return _vm.emitInput(_vm.data, validator)
                              },
                            },
                            model: {
                              value: _vm.data.count,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "count", $$v)
                              },
                              expression: "data.count",
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  130515466
                ),
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.data.type == "Skład wagonowy"
      ? _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("IcFormCarriage", {
                attrs: { withCount: true, maxCarriages: 8 },
                model: {
                  value: _vm.data.carriages,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "carriages", $$v)
                  },
                  expression: "data.carriages",
                },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }